import { ReactNode } from 'react';
import { Alert } from 'antd';
import { LocationCardCompacted } from '../../../components/model/business/FieldsGroup';
import { ProjectGroup } from '../../../components/design/projectgroup/ProjectGroup';
import { MassiveGroupHeader } from '../../menuInfo/common/MassiveGroupHeader';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import './Drawer.css';

export const DRAWER_PANEL_BG = '#F4F7FA';

export const drawerPanelStyles = {
	headerStyle: { background: DRAWER_PANEL_BG },
	bodyStyle: { background: DRAWER_PANEL_BG },
};

export const modalPanelStyles = {
	className: 'lzm-panel-modal',
	bodyStyle: { background: DRAWER_PANEL_BG },
};

type DrawerPanelTitleProps = {
	title: ReactNode;
	subtitle?: ReactNode;
	location?: any;
	/** `true` = proyecto, `false` = grupo (mismo formato que el selector del header) */
	isProject?: boolean;
	locationsCount?: number;
	/** Usa MassiveGroupHeader (locales + grupo) en lugar del Alert */
	massive?: boolean;
	groupName?: string;
	extra?: ReactNode;
};

export const DrawerPanelTitle = ({
	title,
	subtitle,
	location,
	isProject,
	locationsCount,
	massive,
	groupName,
	extra,
}: DrawerPanelTitleProps) => {
	const { projectGroup } = useAuth();
	const resolvedGroupName = groupName ?? projectGroup?.groupName;

	const renderScope = () => {
		if (location) {
			return <LocationCardCompacted location={location} />;
		}
		if (massive && locationsCount != null) {
			return <MassiveGroupHeader numberOfLocations={locationsCount} />;
		}
		if (isProject !== undefined) {
			return <ProjectGroup isProject={isProject} />;
		}
		if (locationsCount != null) {
			return (
				<Alert
					showIcon
					type="info"
					message={
						<>
							{`${locationsCount} locales`}
							{resolvedGroupName ? ` · ${resolvedGroupName}` : null}
						</>
					}
				/>
			);
		}
		return extra ?? null;
	};

	const scope = renderScope();

	return (
		<div
			className="lzm-panel-title"
			style={{
				display: 'flex',
				justifyContent: scope ? 'space-between' : 'flex-start',
				alignItems: 'center',
				gap: 16,
				color: 'LightSlateGray',
				width: '100%',
				boxSizing: 'border-box',
				overflow: 'visible',
			}}
		>
			<div>
				<h2 style={{ color: 'LightSlateGray', margin: 0 }}>
					<b>{title}</b>
				</h2>
				{subtitle ? (
					<p style={{ color: 'LightSlateGray', margin: '2px 0 0', fontSize: 13 }}>
						{subtitle}
					</p>
				) : null}
			</div>
			{scope ? <div style={{ flexShrink: 0 }}>{scope}</div> : null}
		</div>
	);
};
